var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 319,
    viewBox: "0 0 430 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-svg 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 482238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.92,
    filter: "url(#filter0_d_3227_19980)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M318 48H292C289.791 48 288 49.7909 288 52V78C288 80.2091 289.791 82 292 82H318C320.209 82 322 80.2091 322 78V52C322 49.7909 320.209 48 318 48Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M306.079 67.8579H308.123V69.9999H301.207V67.8579H303.335V63.3779H301.207V61.7679C301.795 61.7306 302.457 61.5672 303.195 61.2779C303.932 60.9792 304.581 60.6386 305.141 60.2559H306.079V67.8579ZM312.144 67.4379V69.9999H309.47V67.4379H312.144Z",
    fill: "url(#paint0_linear_3227_19980)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.92,
    filter: "url(#filter1_d_3227_19980)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102 146H76C73.7909 146 72 147.791 72 150V176C72 178.209 73.7909 180 76 180H102C104.209 180 106 178.209 106 176V150C106 147.791 104.209 146 102 146Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88.7179 158.256C89.3992 158.256 89.9966 158.391 90.5099 158.662C91.0326 158.923 91.4339 159.287 91.7139 159.754C92.0032 160.221 92.1479 160.757 92.1479 161.364C92.1479 162.036 91.9752 162.615 91.6299 163.1C91.2846 163.576 90.7432 164.071 90.0059 164.584L88.4799 165.648H92.1619V168H84.6719V167.496C84.6719 166.955 84.7559 166.497 84.9239 166.124C85.0919 165.751 85.3812 165.401 85.7919 165.074L88.5639 162.89C89.0679 162.489 89.3199 161.999 89.3199 161.42C89.3199 161.149 89.2219 160.921 89.0259 160.734C88.8392 160.538 88.6106 160.44 88.3399 160.44H88.1579C87.8872 160.44 87.6539 160.533 87.4579 160.72C87.2712 160.907 87.1779 161.14 87.1779 161.42V161.812H84.7139V161.546C84.7139 160.93 84.8539 160.375 85.1339 159.88C85.4139 159.376 85.8246 158.979 86.3659 158.69C86.9072 158.401 87.5466 158.256 88.2839 158.256H88.7179ZM96.1412 165.438V168H93.4672V165.438H96.1412Z",
    fill: "url(#paint1_linear_3227_19980)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.92,
    filter: "url(#filter2_d_3227_19980)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M174 216H148C145.791 216 144 217.791 144 220V246C144 248.209 145.791 250 148 250H174C176.209 250 178 248.209 178 246V220C178 217.791 176.209 216 174 216Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M160.72 228.256C161.373 228.256 161.952 228.373 162.456 228.606C162.969 228.839 163.366 229.157 163.646 229.558C163.935 229.95 164.08 230.384 164.08 230.86C164.08 231.345 163.958 231.779 163.716 232.162C163.482 232.535 163.16 232.806 162.75 232.974C163.263 233.151 163.66 233.445 163.94 233.856C164.22 234.267 164.36 234.766 164.36 235.354C164.36 235.877 164.215 236.348 163.926 236.768C163.646 237.188 163.23 237.524 162.68 237.776C162.129 238.019 161.476 238.14 160.72 238.14H160.132C159.376 238.14 158.722 238.019 158.172 237.776C157.621 237.524 157.201 237.188 156.912 236.768C156.632 236.348 156.492 235.881 156.492 235.368V235.074H158.956C158.956 235.363 159.049 235.601 159.236 235.788C159.422 235.965 159.702 236.054 160.076 236.054H160.454C160.818 236.054 161.093 235.956 161.28 235.76C161.476 235.564 161.574 235.298 161.574 234.962C161.574 234.635 161.48 234.388 161.294 234.22C161.116 234.043 160.883 233.954 160.594 233.954H159.138V232.232H160.37C160.659 232.232 160.892 232.148 161.07 231.98C161.256 231.803 161.35 231.551 161.35 231.224C161.35 230.981 161.252 230.776 161.056 230.608C160.869 230.431 160.64 230.342 160.37 230.342H160.118C159.847 230.342 159.614 230.431 159.418 230.608C159.231 230.776 159.138 230.981 159.138 231.224H156.8V230.874C156.8 230.389 156.944 229.95 157.234 229.558C157.523 229.157 157.934 228.839 158.466 228.606C158.998 228.373 159.609 228.256 160.3 228.256H160.72ZM168.143 235.438V238H165.469V235.438H168.143Z",
    fill: "url(#paint2_linear_3227_19980)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.92,
    filter: "url(#filter3_d_3227_19980)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M289 146H263C260.791 146 259 147.791 259 150V176C259 178.209 260.791 180 263 180H289C291.209 180 293 178.209 293 176V150C293 147.791 291.209 146 289 146Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M276.154 158.256C276.079 158.723 275.878 159.32 275.552 160.048C275.234 160.776 274.866 161.495 274.446 162.204C274.026 162.904 273.648 163.445 273.312 163.828H275.412V162.4C275.654 162.064 275.934 161.541 276.252 160.832C276.578 160.123 276.788 159.572 276.882 159.18H278.044V163.828H279.416V165.886H278.044V168H275.412V165.886H271.492V163.8C271.856 163.147 272.131 162.587 272.318 162.12L272.738 161.084C273.223 159.889 273.536 158.947 273.676 158.256H276.154ZM283.143 165.438V168H280.469V165.438H283.143Z",
    fill: "url(#paint3_linear_3227_19980)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3227_19980",
    x: 287,
    y: 48,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.593372 0 0 0 0 0.523611 0 0 0 0 0.604167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3227_19980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3227_19980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3227_19980",
    x: 71,
    y: 146,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.593372 0 0 0 0 0.523611 0 0 0 0 0.604167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3227_19980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3227_19980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3227_19980",
    x: 143,
    y: 216,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.593372 0 0 0 0 0.523611 0 0 0 0 0.604167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3227_19980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3227_19980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3227_19980",
    x: 258,
    y: 146,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.593372 0 0 0 0 0.523611 0 0 0 0 0.604167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3227_19980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3227_19980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3227_19980",
    x1: 300.861,
    y1: 75.8276,
    x2: 316.154,
    y2: 71.4154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3227_19980",
    x1: 84.8579,
    y1: 173.828,
    x2: 100.151,
    y2: 169.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3227_19980",
    x1: 156.86,
    y1: 243.828,
    x2: 172.153,
    y2: 239.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3227_19980",
    x1: 271.86,
    y1: 173.828,
    x2: 287.153,
    y2: 169.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLayer1);
export default __webpack_public_path__ + "static/media/mob-layer-1.8ade1b47e04699e9ff49bedb3d7725a0.svg";
export { ForwardRef as ReactComponent };